// src/pages/Enseignants/PassagesGrades/components/GradeAdherentsGrid.jsx

import React, { useEffect, useMemo, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import GradeAdherentCard from "./GradeAdherentCard";

const GradeAdherentsGrid = ({
  adherents,
  savingId,
  onQuickGrade,
  onOpenDrawer,
  pageSize = 24,
}) => {
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [adherents]);

  const maxPage = Math.max(1, Math.ceil((adherents?.length || 0) / pageSize));

  const pageData = useMemo(() => {
    const end = page * pageSize;
    return (adherents || []).slice(0, end);
  }, [adherents, page, pageSize]);

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
        {pageData.map((adherent) => (
          <GradeAdherentCard
            key={adherent.id}
            adherent={adherent}
            saving={savingId === adherent.id}
            onQuickGrade={onQuickGrade}
            onOpenDrawer={onOpenDrawer}
          />
        ))}
      </div>

      {page < maxPage && (
        <div className="flex justify-center">
          <button
            type="button"
            onClick={() => setPage((current) => current + 1)}
            className="inline-flex items-center gap-2 rounded-2xl bg-slate-900 px-5 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-slate-800 dark:bg-white dark:text-slate-950 dark:hover:bg-slate-200"
          >
            Afficher plus
            <FaChevronDown />
          </button>
        </div>
      )}
    </div>
  );
};

export default GradeAdherentsGrid;